import {
  IconBrandProducthunt,
  IconBuildingAirport,
  IconBuildingCarousel,
  IconBuildingStore,
  IconFileInvoice,
  IconGauge,
  IconHistory,
  IconInfoCircle,
  IconInvoice,
  IconMan,
  IconManFilled,
  IconManualGearboxFilled,
  IconMenuOrder,
  IconMoneybag,
  IconMoneybagEdit,
  IconMoneybagHeart,
  IconMoneybagPlus,
  IconMonkeybar,
  IconMoodCheck,
  IconPackage,
  IconPhoneCall,
  IconReport,
  IconReportAnalytics,
  IconReportMoney,
  IconReportSearch,
  IconScale,
  IconSnowman,
  IconSTurnDown,
  IconSum,
  IconUser,
} from "@tabler/icons-react";
import { ReactNode } from "react";

export type MenuLabel =
  | "Debtor Management"
  | "Debtors"
  | "Data Entry"
  | "Payments"
  | "Credit Notes"
  | "Credit Journals"
  | "Debit Journals"
  | "Suppliers"
  | "Invoices"
  | "Sales Profit Margin"
  | "Reports & Exports"
  | "Customer Order History"
  | "Statements & System Aging"
  | "Products"
  | "Customer List"
  | "Supplier Ordering"
  | "Customer Balance Overview"
  | "Product Management"
  | "Product Recall"
  | "Order Management"
  | "Email Statement/Invoices"
  | "Supplier Management"
  | "Aged Trial Balance"
  | "Overdue Accounts"
  | "Process EOY Aging"
  | "Sales Person by Month (all)"
  | "Process EOM Aging"
  | "Sales Person"
  | "Gross Profit Margins"
  | "Sales Analysis"
  | "Stock Balance Summary"
  | "Product Stock Level"
  | "Customer Orders"
  | "Product Price Lists"
  | "Staff";

export type CountableMenuLabel = "Debtors" | "Data Entry" | "Suppliers";
export type CountableDEMenuLabel =
  | "Order Management"
  | "Payments"
  | "Credit Notes"
  | "Credit Journals"
  | "Debit Journals"
  | "Supplier Ordering";

interface AdminNavLink {
  label: MenuLabel; // <-- THIS is the fix
  icon: ReactNode;
  items: {
    label: MenuLabel;
    icon: any;
    href: string;
  }[];
}

// Admin navigation links
export const AdminNavLinks: AdminNavLink[] = [
  {
    label: "Debtors",
    icon: "👨‍🍳",
    items: [
      {
        label: "Debtor Management",
        icon: IconSnowman,
        href: "/admin/enquire-debtors",
      },
    ],
  },
  {
    label: "Data Entry",
    icon: "🍌",
    items: [
      { label: "Order Management", icon: IconMenuOrder, href: "/admin/orders" },
      { label: "Invoices", icon: IconInvoice, href: "/admin/invoices" },
      { label: "Payments", icon: IconMoneybag, href: "/admin/payments" },
      {
        label: "Credit Notes",
        icon: IconMoneybagEdit,
        href: "/admin/credit-notes",
      },
      {
        label: "Credit Journals",
        icon: IconMoneybagHeart,
        href: "/admin/credit-journals",
      },
      {
        label: "Debit Journals",
        icon: IconMoneybagPlus,
        href: "/admin/debit-journals",
      },
    ],
  },
  {
    label: "Reports & Exports",
    icon: "⚖",
    items: [
      {
        label: "Customer Balance Overview",
        icon: IconScale,
        href: "/admin/debtor-balance",
      },
      {
        label: "Customer List",
        icon: IconSTurnDown,
        href: "/admin/debtor-lists",
      },

      {
        label: "Customer Order History",
        icon: IconHistory,
        href: "/admin/cust-order-history",
      },
      {
        label: "Customer Orders",
        icon: IconReportMoney,
        href: "/admin/customer-orders",
      },
      {
        label: "Stock Balance Summary",
        icon: IconSum,
        href: "/admin/stock-balance",
      },
      {
        label: "Product Price Lists",
        icon: IconReportAnalytics,
        href: "/admin/price-list",
      },
      {
        label: "Product Stock Level",
        icon: IconBuildingStore,
        href: "/admin/stock-on-hand",
      },

      {
        label: "Sales Analysis",
        icon: IconReport,
        href: "/admin/sales-analysis",
      },
      {
        label: "Sales Profit Margin",
        icon: IconMonkeybar,
        href: "/admin/sales-profit-margins",
      },

      { label: "Sales Person", icon: IconMan, href: "/admin/sales-person" },
      {
        label: "Sales Person by Month (all)",
        icon: IconManFilled,
        href: "/admin/sales-person-by-month",
      },
      {
        label: "Overdue Accounts",
        icon: IconMoodCheck,
        href: "/admin/overdue-accounts",
      },
      {
        label: "Gross Profit Margins",
        icon: IconReportSearch,
        href: "/admin/gross-profit-margins",
      },
    ],
  },
  {
    label: "Statements & System Aging",
    icon: "💫",
    items: [
      {
        label: "Email Statement/Invoices",
        icon: IconFileInvoice,
        href: "/admin/statement-invoices",
      },
      {
        label: "Process EOM Aging",
        icon: IconManualGearboxFilled,
        href: "/admin/eom",
      },
      {
        label: "Process EOY Aging",
        icon: IconManualGearboxFilled,
        href: "/admin/eoy",
      },
      {
        label: "Aged Trial Balance",
        icon: IconGauge,
        href: "/admin/aged-trial-balance",
      },
    ],
  },
  {
    label: "Products",
    icon: "🧺",
    items: [
      {
        label: "Product Management",
        icon: IconBrandProducthunt,
        href: "/admin/enquire-products",
      },
      {
        label: "Product Recall",
        icon: IconReportSearch,
        href: "/admin/product-recall",
      },
    ],
  },
  {
    label: "Suppliers",
    icon: "🍎",
    items: [
      {
        label: "Supplier Management",
        icon: IconBuildingAirport,
        href: "/admin/enquire-suppliers",
      },
      {
        label: "Supplier Ordering",
        icon: IconBuildingCarousel,
        href: "/admin/supplier-orders",
      },
    ],
  },
];

//
export const DefaultNavLinks = [
  {
    link: "/",
    label: "Home",
    icon: IconPackage,
  },
  {
    link: "/products",
    label: "Products",
    icon: IconPackage,
  },
  {
    link: "/about-us",
    label: "About Us",
    icon: IconInfoCircle,
  },
  {
    link: "/contact-us",
    label: "Contact Us",
    icon: IconPhoneCall,
  },
  {
    link: "/my-accounts",
    label: "My Accounts",
    icon: IconUser,
    restrictedToMembers: true,
  },
];
